import store from '../store';
import { googleGA, userIdStorageKey } from '@/config'
import localforage from 'localforage';

const needAuth = auth => auth === true;
const authRouteName = 'auth.login';

const beforeEach = (to, from, next) => {
  const auth = to.meta.requiresAuth;

  localforage.getItem(userIdStorageKey).then((userId) => {

    if (userId) {
      gtag('config', googleGA, {
        'user_id': userId
      });
      gtag('set', 'user_properties', {
        'id_usuario': userId
      });
    } else {
      gtag('config', googleGA);
    }

  });

  /**
   * Clears all global feedback message
   * that might be visible
   */
  store.dispatch('clearMessages');

  /**
   * If route doesn't require authentication be normally accessed.
   */
  if (!needAuth(auth)) {
    next();
    return; // return to prevent the code from continuing in its flow
    // With this flow `else` or `else if` is not necessary
  }

  /**
   * Otherwise  if authentication is required login.
   */
  store.dispatch('auth/checkUser')
    .then(() => {
      // There is a token and it is valid
      next(); // can access the route
    })
    .catch((err) => {
      // No token, or it is invalid
      next({
        name: authRouteName
      }); // redirect to login
    });
}

export default beforeEach;



// WEBPACK FOOTER //
// ./src/router/beforeEach.js